import { Alert } from '@creditornot/cb-alert';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import useUser from 'common/hooks/useUser';

export const DeprecationNote = ({ featureToBeDeprecated }: { featureToBeDeprecated: string }) => {
  const intl = useIntl();
  const user = useUser();

  if (!user.isEmployee) {
    return null;
  }

  return (
    <Alert
      variant="warning"
      title={intl.formatMessage({ id: 'menu.migration.deprecation-warning.title' })}
      style={{ margin: '16px' }}
    >
      <FormattedMessage
        id="menu.migration.deprecation-warning.message"
        values={{
          br: <br />,
          featureToBeDeprecated,
        }}
      />
    </Alert>
  );
};
